import { Settings } from 'luxon'
import { DateTime } from 'luxon-business-days'

export function usePluginLuxon(): void {
  // TODO: `defaultLocale` does NOT have a setter - should not be overwritten
  Settings.defaultLocale = 'sv'
  Settings.defaultZone = 'utc'

  const dt = DateTime.local()
  const { availableHolidayMatchers } = dt

  dt.setupBusiness({
    holidayMatchers: [
      availableHolidayMatchers.isNewYearsDay,
      availableHolidayMatchers.isEasterDay,
      isEpiphany,
      isFirstOfMay,
      isNationalDay,
      availableHolidayMatchers.isChristmasDay,
    ],
  })
}

function isEpiphany(current: DateTime): boolean {
  const matchesMonth = current.month === 1
  const matchesDay = current.day === 6

  return matchesMonth && matchesDay
}

function isFirstOfMay(current: DateTime): boolean {
  const matchesMonth = current.month === 3
  const matchesDay = current.day === 1

  return matchesMonth && matchesDay
}

function isNationalDay(current: DateTime): boolean {
  const matchesMonth = current.month === 6
  const matchesDay = current.day === 6

  return matchesMonth && matchesDay
}
